import './EditFunctionModal.scss';
class EditFunctionModalController {
    static $inject = ['close', 'actions', 'confirm', 'PipelineActionService', 'PipelineBuilderSegmentService', '$translate'];
    constructor(close, actions, confirm, PipelineActionService, PipelineBuilderSegmentService, $translate) {
        'ngInject';
        this.close = close;
        this.actions = actions;
        this.confirm = confirm;
        this.PipelineActionService = PipelineActionService;
        this.PipelineBuilderSegmentService = PipelineBuilderSegmentService;
        this.$translate = $translate;
        this.itemHeight = 20;
        this.maxHeight = 330;
        this.trackingExecuted = false;
        this.UNIQUE_FUNCTION = 'subtitle-unique-modal';
        this.MULTIPLE_FUNCTION = 'subtitle-multiple-modal';
        this._close = this.close;
        this.multipleApplicationsUsingFunction = false;
    }
    async $onInit() {
        if (!this.actions) {
            this.actions = this.PipelineActionService.getActions();
        }
    }
    async initialSettings() {
        const totalApplications = this.actions.applications.length;
        const subtitleId = totalApplications === 0
            ? this.UNIQUE_FUNCTION
            : this.MULTIPLE_FUNCTION;
        totalApplications === 0
            ? (this.multipleApplicationsUsingFunction = false)
            : (this.multipleApplicationsUsingFunction = true);
        const translationKey = totalApplications === 0
            ? 'builder-tabs-actions.message.modal.functionNoUsing.change.subtitle'
            : 'builder-tabs-actions.message.modal.functionUsing.change.subtitle';
        const subtitleElement = document.getElementById(subtitleId);
        if (subtitleElement) {
            const messageSubtitle = await this.$translate(translationKey);
            const updatedSubtitle = messageSubtitle.replace('{nameFunction}', `<strong>${this.actions.functionName}</strong>`);
            subtitleElement.innerHTML = updatedSubtitle;
        }
        if (!this.trackingExecuted) {
            this.trackingExecuted = true;
            if (this.multipleApplicationsUsingFunction) {
                this.PipelineBuilderSegmentService.trackBlockActionFunctionsEditedModalImpacted({
                    Location: 'Library',
                    BotsImpacted: totalApplications,
                    Description: 'O tracking é disparado ao surgir o modal de edição com bots impactados.',
                });
            }
            else {
                this.PipelineBuilderSegmentService.trackBlockActionFunctionsEditedModal({
                    Location: 'Library',
                    Description: 'O tracking é disparado ao surgir o modal de exclusão SEM bots impactados.',
                });
            }
        }
    }
    async _handleLinkClick() {
        this.PipelineBuilderSegmentService.trackBlockActionFunctionsModalRedirectToBot({
            Location: 'Library',
            ModalType: 'Edit',
            Description: 'É disparado se o usuário clicar em qualquer link que redireciona ele para algum bot impactado',
        });
    }
    async _confirm(choose) {
        this.confirm(choose);
        this._close(true);
    }
    async cancel() {
        this._close(false);
    }
    getContainerHeight() {
        const visibleItemsCount = this.actions.applications.length;
        const height = Math.min(visibleItemsCount * this.itemHeight, this.maxHeight);
        return `${height}px`;
    }
}
EditFunctionModalController.$inject = ['close', 'actions', 'confirm', 'PipelineActionService', 'PipelineBuilderSegmentService', '$translate'];
export default EditFunctionModalController;
